export default __webpack_public_path__ + "static/media/logo-broken.1c9d242b.svg";